/* ZAN theme — global.js (vanilla, no dependencies) */
(function () {
  'use strict';

  var overlay = null;
  var openDrawer = null;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Money formatting ---------- */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '{{ amount }}';
    var value = '';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    function withDelims(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var negative = num < 0 ? '-' : '';
      var fixed = (Math.abs(num) / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
      return negative + whole + (parts[1] ? decimal + parts[1] : '');
    }
    switch (key) {
      case 'amount': value = withDelims(cents, 2); break;
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelims(cents, 2, ' ', '.'); break;
      default: value = withDelims(cents, 3); break; // 3-decimal currencies (KWD)
    }
    if (/amount.*3|3.*amount/.test(key) || key === 'amount_with_3_decimals') value = withDelims(cents, 3);
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  window.zanFormatMoney = formatMoney;

  /* ---------- Drawer placement ----------
     The menu drawer is authored inside the header section, but that section's
     wrapper is sticky with a z-index, which makes it a stacking context — so the
     drawer would be trapped below the page overlay and un-clickable no matter how
     high its own z-index is. Re-parenting it to <body> puts the drawer, the
     overlay and the cart drawer in one stacking layer, where z-index works. */
  function hoistDrawers() {
    qsa('.drawer').forEach(function (d) {
      if (d.parentElement && d.parentElement !== document.body) {
        document.body.appendChild(d);
      }
    });
  }
  hoistDrawers();
  // Theme editor re-renders sections; re-hoist when that happens.
  document.addEventListener('shopify:section:load', hoistDrawers);

  /* ---------- Overlay + drawers ---------- */
  function getOverlay() {
    if (!overlay) overlay = qs('[data-overlay]');
    return overlay;
  }

  function openDrawerEl(el) {
    if (!el) return;
    if (openDrawer && openDrawer !== el) closeDrawerEl(openDrawer);
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    var ov = getOverlay();
    if (ov) { ov.hidden = false; requestAnimationFrame(function () { ov.classList.add('is-visible'); }); }
    document.body.style.overflow = 'hidden';
    openDrawer = el;
    var focusable = el.querySelector('button, a, input');
    if (focusable) focusable.focus({ preventScroll: true });
  }

  function closeDrawerEl(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    var ov = getOverlay();
    if (ov) {
      ov.classList.remove('is-visible');
      setTimeout(function () { if (!openDrawer || !openDrawer.classList.contains('is-open')) ov.hidden = true; }, 300);
    }
    document.body.style.overflow = '';
    if (openDrawer === el) openDrawer = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawerEl(qs(opener.getAttribute('data-drawer-open')));
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawerEl(closer.closest('.drawer') || openDrawer);
      return;
    }
    if (e.target.matches('[data-overlay]') && openDrawer) closeDrawerEl(openDrawer);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawer) closeDrawerEl(openDrawer);
  });

  /* ---------- Sticky header ----------
     The section-group wrapper is what actually sticks (see base.css); it also
     carries .is-compact, which collapses the announcement bar on scroll.
     Reads are batched into rAF so scrolling stays off the critical path. */
  var header = qs('.site-header');
  if (header) {
    // Belt-and-braces: header.liquid tags its wrapper inline, but if that script
    // was stripped (some app/proxy setups), tag it here too.
    var stickyRoot = header.parentElement;
    if (stickyRoot && stickyRoot !== document.body && stickyRoot !== document.documentElement) {
      stickyRoot.classList.add('site-header-sticky');
    }
    var ticking = false;

    var applyScrollState = function () {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      header.classList.toggle('is-scrolled', y > 8);
      ticking = false;
    };

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(applyScrollState);
    }, { passive: true });

    applyScrollState(); // correct state on load / reload mid-page
  }

  /* ---------- Quantity inputs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty-input');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.min || '1', 10);
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    var val = Math.min(max, Math.max(min, (parseInt(input.value, 10) || min) + delta));
    if (val !== parseInt(input.value, 10)) {
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---------- Cart (AJAX) ---------- */
  function refreshCart(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#CartDrawer');
          var current = qs('#CartDrawer');
          if (fresh && current) {
            var wasOpen = current.classList.contains('is-open');
            current.innerHTML = fresh.innerHTML;
            if (wasOpen) current.classList.add('is-open');
          }
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? cart.item_count : '';
        });
        if (openAfter) openDrawerEl(qs('#CartDrawer'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      });
  }
  window.zanRefreshCart = refreshCart;

  function addToCart(body) {
    return fetch(window.theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  /* Product form submit */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-atc-button]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = window.theme.strings.addToCart + '...'; }
    var fd = new FormData(form);
    addToCart({
      items: [{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) }]
    }).then(function () {
      if (btn) btn.textContent = window.theme.strings.added;
      return refreshCart(true);
    }).catch(function (err) {
      alert((err && err.description) || window.theme.strings.cartError);
    }).finally(function () {
      if (btn) setTimeout(function () { btn.textContent = original; btn.removeAttribute('aria-disabled'); }, 1500);
    });
  });

  /* Quick add buttons */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    btn.classList.add('is-loading');
    addToCart({ items: [{ id: parseInt(btn.getAttribute('data-quick-add'), 10), quantity: 1 }] })
      .then(function () { return refreshCart(true); })
      .catch(function (err) { alert((err && err.description) || window.theme.strings.cartError); })
      .finally(function () { btn.classList.remove('is-loading'); });
  });

  /* Cart line quantity / remove */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-line-qty'), parseInt(input.value, 10));
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-remove]');
    if (!btn) return;
    e.preventDefault();
    changeLine(btn.getAttribute('data-line-remove'), 0);
  });

  function changeLine(key, quantity) {
    fetch(window.theme.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return refreshCart(false);
    }).then(function (cart) {
      // If we're on the cart page, re-render it
      var cartPage = qs('[data-cart-page]');
      if (cartPage) window.location.reload();
    }).catch(function () { alert(window.theme.strings.cartError); });
  }

  /* Cart note */
  document.addEventListener('change', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch(window.theme.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value })
    });
  });

  /* ---------- Product gallery ---------- */
  qsa('[data-gallery]').forEach(function (gallery) {
    var track = qs('.gallery__track', gallery);
    var thumbs = qsa('.gallery__thumbs button', gallery);
    if (!track) return;
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        var slide = track.children[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
    });
    if (thumbs.length) {
      track.addEventListener('scroll', function () {
        var i = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      }, { passive: true });
    }
  });

  /* ---------- Slideshow ---------- */
  qsa('[data-slideshow]').forEach(function (slideshow) {
    var track = qs('.slideshow__track', slideshow);
    var dots = qsa('.slideshow__dot', slideshow);
    var autoplay = parseInt(slideshow.getAttribute('data-autoplay') || '0', 10);
    if (!track || track.children.length < 2) return;
    var timer = null;
    function goTo(i) {
      var slide = track.children[i];
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });
    track.addEventListener('scroll', function () {
      var i = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }, { passive: true });
    function startAuto() {
      if (!autoplay) return;
      stopAuto();
      timer = setInterval(function () {
        var i = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
        goTo((i + 1) % track.children.length);
      }, autoplay * 1000);
    }
    function stopAuto() { if (timer) clearInterval(timer); }
    slideshow.addEventListener('pointerenter', stopAuto);
    slideshow.addEventListener('pointerleave', startAuto);
    startAuto();
  });

  /* ---------- Sticky mobile ATC ---------- */
  var stickyAtc = qs('[data-sticky-atc]');
  var buyBlock = qs('[data-buy-block]');
  if (stickyAtc && buyBlock && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyAtc.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(buyBlock);
    var stickyBtn = qs('[data-sticky-atc-btn]', stickyAtc);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = qs('form[data-product-form]');
        if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
  }

  /* ---------- Predictive search ---------- */
  qsa('[data-predictive-search]').forEach(function (wrap) {
    var input = qs('input[type="search"]', wrap);
    var results = qs('[data-predictive-results]', wrap);
    if (!input || !results) return;
    var t = null;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (((data.resources || {}).results || {}).products) || [];
            if (!products.length) {
              results.innerHTML = '<p style="opacity:.6;font-size:1.35rem;padding:.8rem">' + window.theme.strings.noResults + '</p>';
              return;
            }
            results.innerHTML = products.map(function (p) {
              var img = p.featured_image && p.featured_image.url
                ? '<img src="' + p.featured_image.url + '&width=96" alt="" loading="lazy">'
                : '<span style="width:4.8rem;height:4.8rem;border-radius:.6rem;background:rgb(var(--color-surface));display:block"></span>';
              return '<a href="' + p.url + '">' + img +
                '<span><span class="title">' + p.title + '</span><br>' +
                '<span class="price">' + (p.price ? formatMoney(parseFloat(p.price) * 100) : '') + '</span></span></a>';
            }).join('');
          });
      }, 250);
    });
  });
})();
